/** * START NEW SEARCH LOGIC **/

    // 1. Global state for pagination
    let currentSearchPage = 1;
    let keywords = [];
    // Assume you have a spinner element with the ID 'spinner'
    const spinner = document.getElementById('spinner');
    var dateFormat = 'dd/mm/yy';
    let currentPage = 1;
let isLoading = false;

const fatalityCategory = (categroy) => {
            switch (categroy) {
                case "Brigades":
                    return 'Brigades';
                    break;
                case "Operations":
                    return 'Operations';
                    break;
                case "Civil War":
                    return 'civil-war';
                    break;
                case "War of Independence":
                    return 'war-of-independence';
                    break;
                case "Truce":
                    return 'truce';
                    break;
                default:
                    return 'All';
            }
        };


// Scope and field values of the last MSPC multi-field search (set in search/results.twig), so the
// next pages repeat it - but only while still browsing an MSPC collection. window.mspcActiveSearch
// is set once and never cleared, so without the collection check, switching to an unrelated
// collection (Nominal Rolls, Online Collections, etc.) kept sending the stale MSPC scope/fields,
// which actionSearchscroll then applied to that collection's query too, returning zero results for
// an otherwise normal search.
const MSPC_COLLECTION_IDS = ['mspc_medals_pensions', 'mspa_pensions', 'mspa_medals', 'archive_catalogue_member', 'archive_catalogue_admin'];
// A new quick search starts a new search session, so the MSPC panel's filters (radios included)
// and its remembered search must not ride along into it or into the pages scrolled after it.
function clearMspcPanelState() {
    window.mspcActiveSearch = null;
    document.querySelectorAll('.mspc-field input[type="text"], .mspc-field select').forEach((field) => {
        field.value = '';
    });
    document.querySelectorAll('.mspc-field input[type="radio"]').forEach((radio) => {
        radio.checked = false;
    });
}

function mspcSearchParams(collection) {
    const search = window.mspcActiveSearch;
    if (!search || !MSPC_COLLECTION_IDS.includes(collection)) {
        return {};
    }
    return {mspcScope: search.scope, mspcFields: search.fields};
}

// Minimum length of typed search text (openspec change search-min-length). The number and the message
// come from the server (data attributes on #gsearch, written from SearchInputGuard); 3 is only the
// fallback if the attributes are missing. Inputs that take words carry the class js-search-text.
function searchMinLength() {
    const form = document.getElementById('gsearch');
    const min = parseInt(form && form.dataset.minLength, 10);
    return min > 0 ? min : 3;
}

function searchMinLengthMessage() {
    const form = document.getElementById('gsearch');
    return (form && form.dataset.minLengthMessage) || `Please enter at least ${searchMinLength()} characters`;
}

function clearSearchTextMessages() {
    document.querySelectorAll('.search-min-length-msg').forEach((message) => {
        const input = document.querySelector(`[aria-describedby="${message.id}"]`);
        if (input) {
            input.removeAttribute('aria-describedby');
            input.removeAttribute('aria-invalid');
        }
        message.remove();
    });
}

// Shows the message after the input, moves focus to it and removes the message on the next keystroke.
function showSearchTextMessage(input) {
    clearSearchTextMessages();
    const message = document.createElement('div');
    message.id = `${input.id || 'search'}-min-length-msg`;
    message.className = 'search-min-length-msg';
    message.setAttribute('role', 'alert');
    message.textContent = searchMinLengthMessage();
    // The quick-search form and the add-keyword group are flex rows (input + button): put the message
    // below the whole row at full width, not squeezed between the box and its button.
    const row = input.parentElement;
    const anchor = row && getComputedStyle(row).display.includes('flex') ? row : input;
    anchor.insertAdjacentElement('afterend', message);
    input.setAttribute('aria-describedby', message.id);
    input.setAttribute('aria-invalid', 'true');
    input.focus();
    input.addEventListener('input', clearSearchTextMessages, {once: true});
}

// True when the search may be sent. Every typed value must have at least the minimum number of
// characters once trimmed (the whole value, not each word); a search with no typed text needs another
// criterion (a dropdown, a radio, a date, year or age value). Nothing is sent and the results stay as
// they are when this returns false.
function validateSearchText(inputs, hasOtherCriterion = false) {
    const fields = Array.from(inputs).filter(Boolean);
    const min = searchMinLength();
    clearSearchTextMessages();

    let hasText = false;
    for (const input of fields) {
        const value = (input.value || '').trim();
        if (value === '') {
            continue;
        }
        if (Array.from(value).length < min) {
            showSearchTextMessage(input);
            return false;
        }
        hasText = true;
    }

    if (!hasText && !hasOtherCriterion) {
        if (fields.length) {
            showSearchTextMessage(fields[0]);
        }
        return false;
    }

    return true;
}

// Whether a Multi-Field panel (or one MSPC field set) holds a criterion other than typed words: a checked
// checkbox or radio, a dropdown with a value, or a number/date/year/age input with a value.
function panelHasOtherCriterion(panel) {
    if (!panel) {
        return false;
    }
    // Only controls the user can see: a value left in a hidden field of another collection is not sent.
    // Dropdowns are drawn by a custom widget over a hidden native <select>, so the control's own box is
    // not tested: its visible wrapper is.
    const visible = (field) => (field.closest('.form-group, .mspc-field, .input-group') || field.parentElement || field)
        .getClientRects().length > 0;
    // A value the page filled in by itself (the collection's full From/To range, see data-default-value
    // in results.twig) is not a choice the user made.
    const filled = (field) => {
        const value = (field.value || '').trim();
        return visible(field) && value !== '' && value !== 'All' && value !== field.dataset.defaultValue;
    };
    return Array.from(panel.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')).some(visible)
        || Array.from(panel.querySelectorAll('select')).some(filled)
        || Array.from(panel.querySelectorAll('input[type="text"]:not(.js-search-text)')).some(filled);
}

// True when the Multi-Field From/To dates are empty or still the collection's pre-filled range, so the
// server guard does not count them as a criterion either (sent as datesDefault=1).
function multiFieldDatesUntouched() {
    return ['search_from', 'search_to'].every((id) => {
        const field = document.getElementById(id);
        const value = field ? (field.value || '').trim() : '';
        return value === '' || value === field.dataset.defaultValue;
    });
}

// The MSPC Search buttons are wired in an inline script in results.twig, outside this bundle.
window.validateSearchText = validateSearchText;
window.panelHasOtherCriterion = panelHasOtherCriterion;

// The quick-search "Military Service Pensions Collection" option searches through /gs with the
// mspc_medals_pensions collection (see executeSearch). Adding or removing a keyword in the results
// has to repeat that same request with the remaining keywords; the legacy /s endpoint only knows
// the old single-index "mspc" search and fails (500) for the MSPC collection ids (AMI-19).
// Returns the /gs URL for the MSPC quick search, or null for every other kind of search.
function mspcKeywordSearchUrl(keywords) {
    if ($('input[type="radio"][name="searchOptions"]:checked').attr('searchtype') !== 'mspc') {
        return null;
    }
    const params = new URLSearchParams();
    params.set('generalsearch', keywords.join('+ '));
    params.set('page', 1);
    params.set('collection', 'mspc_medals_pensions');
    return `/gs?${params}`;
}

function getKeywordsFromLabels() {
    let keywords = [];

    // Target only the divs with class d-inlineBox
    $('#keywordLabels .d-inlineBox span').each(function() {
        var text = $(this).text().trim();
        // Ensure we aren't picking up symbols or "Results" text
        if (text !== '+' && text !== '=' && text !== 'Results') {
            keywords.push(text);
        }
    });

    return keywords.length > 0 ? keywords.join('+') : $('#generalsearch').val();;
}

// 1. Detect when a user changes the collection (Radio Button)
$(document).on('change', 'input[name="inputAccordion"]:checked:visible, input[name="inputAccordionMobile"]:checked:visible', function() {
    const selectedCollection = $(this).data("collection");
    const selectedStartDate = $(this).data("startdate");
    const selectedEndDate = $(this).data("enddate");
    const queryTerm = getKeywordsFromLabels();
    currentPage = 1;

    if (selectedStartDate === "" && selectedEndDate === "")
    {
        $("#from").attr("placeholder", selectedStartDate);
        $("#to").attr("placeholder", selectedEndDate);
        $("#from").prop("visible", true);
        $("#to").prop("visible", true);
    }
    else
    {
        $("#from").prop("visible", false);
        $("#to").prop("visible", false);
    }

    $('#searchResultsAnchor').html('<div class="loading">Loading...</div>');

    $.ajax({
        url: '/searchscroll', // Your main search action
        method: 'GET',
        data: Object.assign({
            generalsearch: queryTerm,
            collection: selectedCollection,
            page: 1
        }, mspcSearchParams(selectedCollection)),
        success: function(html) {
            // Replace only the inner results anchor
            $('#searchResultsAnchor').html(html);
        }
    });
});

function loadMoreResults() {
    let activeCollection = $('input[name="inputAccordion"]:checked').data("collection");
    let queryParams = new URLSearchParams();
    let selectedCollections = [];
    let request = '/headingfields';
    var isIraChecked = $('#orgIRA').is(':checked');
    const searchInput = $('input[name=generalsearch]').val();
    // Collect year filters
    const selectedYears = [];

    // Check if the screen is mobile sized
    if (window.innerWidth < 992) { 
        activeCollection = $('input[name="inputAccordionMobile"]:checked').data("collection");
    }
    
    if (!activeCollection)
    {
        return;
    } 

    isLoading = true;
    currentPage++;

    if ($('input[name="collectionChoice[]"]:checked').val() && searchInput === '')
    {
        $('input[name=generalsearch]').val("");
        queryParams.set('page', currentPage);
        $('input[name="yearFilter[]"]:checked').each(function () {
            selectedYears.push($(this).val());
        });
        selectedYears.forEach((year) => queryParams.append('year[]', year));

        // Collect organisation filters
        const selectedOrgs = [];
        $('input[name="orgFilter[]"]:checked').each(function () {
            selectedOrgs.push($(this).val());
        });
        selectedOrgs.forEach((org) => queryParams.append('organisation[]', org));

        if ($('#gsearch').attr('action') === 'onlinecollectionssearch') {
                //request = '/onlinecollectionssearch';

                if ($('input[name="collectionChoice[]"]:checked').val() ===
                    "selectAllOnlineCollections") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });

                    switch ($('input[name="collectionChoice[]"]:checked').val()) {
                        case "bmhcdindex":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "mspc":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('section', fatalityCategory($('#search_section_select').val()));
                            break;
                        case "bmhwitnesses":
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('firstname', $('#search_firstnamewitness').val());
                            queryParams.set('surname', $('#search_surnamewitness').val());
                            break;
                        case "bmhgallery":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('caption', $('#search_caption').val());
                            queryParams.set('album', $('#search_album').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            break;
                        case "collins":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "census":
                            queryParams.set('firstname', $('#search_firstname').val());
                            queryParams.set('surname', $('#search_surname').val());
                            queryParams.set('age', $('#search_age').val());
                            queryParams.set('nextofkinfirstname', $('#search_nextofkinfirstname')
                                .val());
                            queryParams.set('nextofkinsurname', $('#search_nextofkinsurname').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "gallery":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('caption', $('#search_caption').val());
                            queryParams.set('album', $('#search_album').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "mpdsearch":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('location', $('#search_location').val());
                            queryParams.set('to', $('#search_year').val());
                            break;
                        case "irishvol":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('subtitle', $('#search_subtitle').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "antoglac":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('subtitle', $('#search_subtitle').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                        case "oralhistories":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('interviewee', $('#search_interviewee').val());
                            queryParams.set('location', $('#search_location').val());
                        case "nominalrolls":
                            queryParams.set('year1921', $('#year1921').is(':checked') ? $('#year1921').val() : '');
                            queryParams.set('year1922', $('#year1922').is(':checked') ? $('#year1922').val() : '');
                            queryParams.set('orgIRA', $('#orgIRA').is(':checked') ? $('#orgIRA').val() : '');
                            queryParams.set('orgCumann', $('#orgCumann').is(':checked') ? $('#orgCumann').val() : '');
                            queryParams.set('orgFianna', $('#orgFianna').is(':checked') ? $('#orgFianna').val() : '');
                            queryParams.set('orgICA', $('#orgICA').is(':checked') ? $('#orgICA').val() : '');

                            // HIDDEN LOGIC: If IRA is checked, also send these specific values
                            // These correspond to the values previously held by orgIrishVol and orgHibernian
                           
                           if (isIraChecked) {
                            // These keys match your PHP $orgs array
                            queryParams.set('orgIrishVol', 'Irish Volunteers');
                            queryParams.set('orgHibernian', 'Hibernian Rifles');
                            
                            // Also keep the individual params if your PHP specifically looks for these keys
                            queryParams.set('orgIrishVol', 'Irish Volunteers');
                            queryParams.set('orgHibernian', 'Hibernian Rifles');
                            } else {
                                queryParams.set('orgIrishVol', '');
                                queryParams.set('orgHibernian', '');
                            }    
                            
                            queryParams.set('search_file_references', $('#search_file_references')
                                .val());
                            queryParams.set('search_firstname', $('#search_firstname').val());
                            queryParams.set('search_surname', $('#search_surname').val());
                            queryParams.set('search_location', $('#search_location').val());
                            queryParams.set('search_address', $('#search_address').val());
                            queryParams.set('search_brigade', $('#search_brigade').val());
                        default:
                            // code block
                    }

                }

                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collection[]', collection);
                });
            }
            if ($('#gsearch').attr('action') === 'readingroomsearch') {
                //request = '/readingroomssearch';

                if ($('input[name="collectionReadingRoomChoice[]"]:checked').val() ===
                    "selectAllReadingRooms") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionReadingRoomChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionReadingRoomChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });
                }
                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collection[]', collection);
                });
            }
            if ($('#gsearch').attr('action') === 'resourcesearch') {
                //request = '/resourcescollectionsearch';

                if ($('input[name="resourcescollectionChoice[]"]:checked').val() ===
                    "selectAllResources") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="resourcescollectionChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                    selectedCollections.push('siteresourcesdata');

                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="resourcescollectionChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });

                    switch ($('input[name="resourcescollectionChoice[]"]:checked').val()) {
                        case "irish-sword":
                            queryParams.set('titleirishsword', $('#search_titleirishsword').val());
                            queryParams.set('season', $('#search_date').val());
                            queryParams.set('articlename', $('#search_articlename').val());
                            queryParams.set('author', $('#search_author').val());
                            queryParams.set('issue', $('#search_issue').val());
                            queryParams.set('volume', $('#search_volume').val());
                            queryParams.set('keyword', $('#search_keywordirishsword').val());
                        default:
                            // code block
                    }

                }

                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collection[]', collection);
                });
            }

            $.ajax({
                url: `${request}?${queryParams}`, // Define the URL here
                method: 'GET', // Good practice to explicitly state the method
                success: function(html) {
                    if (html.trim() !== "") {
                        $('#searchResultsAnchor').append(html); 
                        isLoading = false;
                    } else {
                        $(window).off('scroll'); // Note: See warning below about this!
                    }
                },
                error: function() {
                    isLoading = false; // Always reset loading state on error
                }
            });
    }
    else
    {
            $.ajax({
                url: '/searchscroll', // Points to actionSearchScroll
                method: 'GET',
                data: Object.assign({
                    generalsearch: getKeywordsFromLabels(),
                    page: currentPage,
                    collection: activeCollection
                }, mspcSearchParams(activeCollection)),
                success: function(html) {
                    if (html.trim() !== "") {
                        // Append the new items to your result container
                        $('#searchResultsAnchor').append(html); 
                        isLoading = false;
                    } else {
                        // No more results
                        $(window).off('scroll');
                    }
                }
            });
    }


}

// 2. Infinite Scroll Logic
$(window).on('scroll', function() {
    // Check if we are near the bottom of the results container
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 500) {
        if (!isLoading) {
            loadMoreResults();
        }
    }
});

    function scrollProgress() {
                        var progressPath = document.querySelector('.progress-wrap path');
                        var pathLength = progressPath.getTotalLength();
                        var offset = 900;
                        var duration = 550;
                        var updateProgress = function () {
                            var scroll = $(window).scrollTop();
                            var height = $(document).height() - $(window).height();
                            var progress = pathLength - (scroll * pathLength / height);
                            progressPath.style.strokeDashoffset = progress;
                        };

                        progressPath.style.transition = progressPath.style.WebkitTransition =
                            'none';
                        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
                        progressPath.style.strokeDashoffset = pathLength;
                        progressPath.getBoundingClientRect();
                        progressPath.style.transition = progressPath.style.WebkitTransition =
                            'stroke-dashoffset 10ms linear';
                        
                        updateProgress();
                        $(window).scroll(updateProgress);
                        
                        jQuery(window).on('scroll', function () {
                            if (jQuery(this).scrollTop() > offset) {
                                jQuery('.progress-wrap').addClass('active-progress');
                            } else {
                                jQuery('.progress-wrap').removeClass('active-progress');
                            }
                        });
                        jQuery('.progress-wrap').on('click', function (event) {
                            event.preventDefault();
                            jQuery('html, body').animate({
                                scrollTop: 0
                            }, duration);
                            return false;
                        });
                    }
// The MSPC multi-field search loads its results without the code that sets up the back-to-top button, so set it up here.
$(function () {
    if (document.getElementById('mspcSearchPanel') && document.querySelector('.progress-wrap path')) {
        scrollProgress();
    }
});
function splitKeywords(input) {
        // Split the input string by ', ' and return the result
        return input.split(', ');
    }

    // Function to create a styled box with text and a number
    function createStyledBox(text, number) {
        var box = document.createElement('div');
        var textBox = document.createElement('span');
        var numberBox = document.createElement('span');

        if (text !== "Results")
        {    
            box.className = "d-inlineBox";
        }

        box.style.border = '1px solid black';
        box.style.display = 'inline-block';
        // box.style.margin = '2px';

        box.style.padding = '3px 12px';
        box.style.fontSize = '1.1rem';

            
        textBox.textContent = text;
        box.appendChild(textBox);

        if (text === "Results") {
            box.className = "d-inline";
            numberBox.id = "results";
            numberBox.style.fontWeight = '500';
            box.prepend(numberBox);
        }

        return box;
    }

// Function to create the equation part ('×' or '+')
    function createEquationPart(symbol) {
        var div = document.createElement('div');
        var part = document.createElement('span');

        div.className = "d-inline";
        part.textContent = ` ${symbol} `;
        // part.style.fontSize = '24px';
        part.style.marginRight = "5px";
        // part.style.verticalAlign = 'middle';
        div.appendChild(part);

        return div;
    }

    

    // Function to handle scroll event
    function onScroll() {
        if ($(window).scrollTop() + $(window).height() >= $(document).height() - 800) {
        //showItems();
        }
    }

    function checkboxFiltersAccebility(){
        $('input[name="inputAccordion"], input[name="inputAccordionMobile"]').keyup(function (event) {
            if (event.keyCode === 13) {
                if ($(this).is(':checkbox, :radio')) {
                    $(this).click();
                }
            }
        });
    }

    function checkForMobile() {
        function isMobile() {
            return /Mobi|Android/i.test(navigator.userAgent);
        }

        if (isMobile()) {
            //MIL-308
            $("#search_from").prop('readonly', true);
            $("#search_to").prop('readonly', true);
        }
    }
    
    $('.filter-section').hide();

    //JIRA  MIL-391
    // Select all accordion buttons
    const focusAccordion = () => {
        $('.accordion-button').each(function () {
            var $button = $(this);
            var $targetDiv = $button.closest('.result-item'); // Adjust selector based on your structure
            var $collapseTarget = $($button.data('bs-target'));

            $collapseTarget.on('hidden.bs.collapse', function () {
                // Scroll back to the target div when the accordion is collapsed
                $('html, body').animate({
                    scrollTop: $targetDiv.offset().top
                }, 'slow');
            });
        });
    };

    //MIL-308 add readonly property in mobile for datepickers
    checkForMobile();

    function cleanHideInput() {
        $("#search_title").val('');
        $("#search_file_references").val('');
        $("#search_subtitle").val('');
        $("#search_scope_content").val('');
        $("#search_firstname").val('');
        $("#search_surname").val('');
        $("#search_location").val('');
        $("#search_interviewee").val('');
        $("#search_year").val('');
        $("#search_age").val('');
        $("#search_county").val('');
        $("#search_nextofkinfirstname").val('');
        $("#search_nextofkinsurname").val('');
        $("#search_caption").val('');
        $("#search_album").val('');
        $("#search_volume").val('');
        $("#search_keyword").val('');
        $("#search_articlename").val('');
        $("#search_author").val('');
        $("#search_date").val('');
        $("#search_titleirishsword").val('');
    }

    

    function shouldHideMobileFilter() {
        function isMobile() {
            return /Mobi|Android/i.test(navigator.userAgent);
        }

        if (isMobile()) {
            //hide filters mobile when we search in one collection
            if ((($('input[type="radio"][name="collectionReadingRoomChoice[]"]:checked').length === 1 && $('input[name="collectionReadingRoomChoice[]"]:checked').val() !== "selectAllReadingRooms")) ||
                    ($('input[type="radio"][name="collectionChoice[]"]:checked').length === 1 && $('input[name="collectionChoice[]"]:checked').val() !== "selectAllOnlineCollections") && $('#siteSearch:checked').length === 0) {
                    $('#mobileFiltersButton').css('display', 'none');
            } else {
                $('#mobileFiltersButton').css('display', 'block');
            }

            //MIL-308
            $("#from").prop('readonly', true);
            $("#to").prop('readonly', true);
        }
    }

    

    const datePickerFunction = () => {
        function getDate(element) {
            var date = null;
            try {
                date = $.datepicker.parseDate(dateFormat, element.value);
            } catch (error) {
                date = null;
            }

            return date;
        }

        dateFormat = 'dd/mm/yy';
        let from = $('#from').datepicker({
                    defaultDate: '+1w',
                    showButtonPanel: true,
                    changeMonth: true,
                    changeYear: true,
                    showOtherMonths: true,
                    selectOtherMonths: true,
                    numberOfMonths: 1,
                    dateFormat: dateFormat,
                    yearRange: '1800:' + new Date().getFullYear(), // Year range from 1900 to current year
                    onChangeMonthYear: function (year, month, inst) {
                        setTimeout(() => {
                            const selectedDate = $(this).datepicker('getDate');
                            if (selectedDate) {
                                $('#from').val($.datepicker.formatDate(dateFormat, new Date(
                                    year, month - 1, 1)));
                            }
                        }, 0);
                    },
                })
                .on('change', function () {
                    // Update the '#to' datepicker via selector instead of referencing the `to` variable
                    // (avoids using the `to` binding before it's declared)
            $('#to').datepicker('option', 'minDate', getDate(this));
        });

    let to = $('#to').datepicker({
                    defaultDate: '+1w',
                    showButtonPanel: true,
                    changeMonth: true,
                    changeYear: true,
                    showOtherMonths: true,
                    selectOtherMonths: true,
                    numberOfMonths: 1,
                    dateFormat: dateFormat,
                    yearRange: '1800:' + new Date().getFullYear(), // Year range from 1900 to current year
                    onChangeMonthYear: function (year, month, inst) {

                        setTimeout(() => {
                            const selectedDate = $(this).datepicker('getDate');
                            if (selectedDate) {
                                $('#to').val($.datepicker.formatDate(dateFormat, new Date(
                                    year, month - 1, 1)));
                            }
                        }, 0);
                    },
            })
            .on('change', function () {
                // 'from' was declared above
                from.datepicker('option', 'maxDate', getDate(this));
            });
            // Handle the 'Done' button
            // Remove the 'Done' button
            $(".ui-datepicker-close").remove();
    };

    function convertDate(dateString) {
        // Split the date string 'DD/MM/YYYY' into its components
        const parts = dateString.split('/');
        // Rearrange the parts into 'YYYY-MM-DD'
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

    //display date of collection on datepicker
    const datePickerDates = () => {
            // Define a variable to store the earliest date
            let earliestDate = null;
            let newestDate = null;

            $('.form-check-input[type="radio"]:checked').each(function (index) {
                const startDate = $(this).data('startdate');
                const endDate = $(this).data('enddate');
                var day = null;
                var month = null;
                var year = null;

                // If startDate is valid and either earliestDate is null (not yet set) or startDate is earlier, update earliestDate
                if (startDate && (!earliestDate || new Date(convertDate(startDate)) < new Date(
                        convertDate(earliestDate)))) {
                    day = startDate.substring(0, 2);
                    month = startDate.substring(3, 5);
                    year = startDate.substring(6, 10);
                    //earliestDate = year+"-"+month+"-"+day;
                    earliestDate = day + "/" + month + "/" + year;
                }
                // If startDate is valid and either earliestDate is null (not yet set) or startDate is earlier, update earliestDate
                if (endDate && (!newestDate || new Date(convertDate(endDate)) > new Date(
                        convertDate(newestDate)))) {
                    day = endDate.substring(0, 2);
                    month = endDate.substring(3, 5);
                    year = endDate.substring(6, 10);
                    //newestDate = year+"-"+month+"-"+day;
                    newestDate = day + "/" + month + "/" + year;
                }
            });

            // If an earliest date was found, set it as the value of the input named 'startDate'
            if (earliestDate) {
                $('input[name="startDate"]').val(earliestDate);
            }
            // If an earliest date was found, set it as the value of the input named 'startDate'
            if (newestDate) {
                $('input[name="endDate"]').val(newestDate);
            }
    };

    // Function to filter cards based on selected checkboxes
    function filterCards() {
            // Get all checked checkboxes' data-collection values
            var selectedCollections = $('.form-check-input:checked').map(function () {
                return $(this).data('collection');
            }).get();

            // Select all cards
            var cards = $('div[data-element="card-div"]');

            var isGroupSelected = selectedCollections.includes('sitewide') || 
                          selectedCollections.includes('online_group') || 
                          selectedCollections.includes('reading_room_group') ||
                          selectedCollections.includes('mspc_medals_pensions') ||
                          selectedCollections.length === 0;

            // NEW LOGIC: If no checkboxes are selected OR "sitewide" is selected, show all cards immediately
            if (isGroupSelected) {
                // Show all cards that were returned by the server
                cards.show();
                
            } else {
                // Hide all cards first
                cards.hide();

                // Loop over the cards and show only the ones that match any of the selected checkboxes
                cards.each(function () {
                    var card = $(this);
                    var cardName = card.data('name');

                    // Organizations and Administration are two radios over one index: their cards are
                    // named after the index (archive_catalogue), the server already narrowed the results.
                    if (cardName === 'archive_catalogue' &&
                        (selectedCollections.indexOf('archive_catalogue_member') !== -1 ||
                         selectedCollections.indexOf('archive_catalogue_admin') !== -1)) {
                        card.show();
                        return;
                    }

                    // Check if this card's data-name matches any selected collection
                    if (selectedCollections.indexOf(cardName) !== -1) {
                        card.show();
                    }
                });
            }

            // Bind the scroll event
            $(window).on('scroll', onScroll);
    }

    $('.dropdown-menu li label').click(function (e) {
        e.stopPropagation();
    });

function updateKeywordLabels() {
        const partialViewContainer = document.getElementById('searchResult');
        let labelsContainer = partialViewContainer.querySelector('#keywordLabels');
        const selectedCollection = $('input[type="radio"][name="inputAccordion"]:checked, input[type="radio"][name="inputAccordionMobile"]:checked').data('collection');
        var equalsSign = createEquationPart('=');
        // Create the results box
        var resultsBox = createStyledBox('Results', '');
        labelsContainer.innerHTML = ''; // Clear current labels

        // Shared by the "Clear All" button and by removing the last keyword label: empties the
        // results, clears the search box and returns to the top of the page (AMI-19).
        const clearAllResults = function () {
            keywords = [];
            labelsContainer.remove();
            $('#searchResult').empty();
            $('input[name="generalsearch"]').val('');
            $("html, body").animate({
                scrollTop: 0
            }, 50);
            cleanHideInput();
        };

        keywords.forEach((keyword, index) => {
            //let label = document.createElement('label');
            const keyword_count = keyword.replace(" ", "_");
            // Create the boxes with the respective texts and numbers
            var label = createStyledBox(keyword, 0);
            // Create equation parts
            var plusSign1 = createEquationPart('+');
            var div = document.createElement('div');
            var button = document.getElementById('clearFilters');
            // Container for the whole equation
            var equationContainer = document.createElement('div');
            equationContainer.style.fontFamily = 'jost, sans-serif';
            equationContainer.className = "d-inline-block";
            equationContainer.dataset.keyword = keyword;

            // Append all parts to the container
            equationContainer.appendChild(label);
            if (index !== keywords.length - 1) {
                equationContainer.appendChild(plusSign1);
            }
            // Append the equation container to the document body or another element in the DOM
            document.body.appendChild(equationContainer);

            equationContainer.addEventListener('click', function () {
                let input = $('input[name=generalsearch]').val();
                //delete keyword
                keywords.indexOf(this.dataset.keyword);
                    if (index > -1) { // only splice array when item is found
                        keywords.splice(index, 1); // 2nd parameter means remove one item only
                    }
                    equationContainer.remove();
                    if (keywords.length !== 0) {
                        // Construct the query string
                        let input = $('input[name=generalsearch]').val();
                        let action = "";
                        const selectedTypeSearch = $('input[type="radio"][name="searchOptions"]:checked').attr('searchtype');
                        const checkboxName = action === 'resourcesearch' ? 'resourcescollectionChoice[]' : (action === 'readingroomsearch' ? 'collectionReadingRoomChoice[]' : 'collectionChoice[]');
                        let queryParams = new URLSearchParams();

                        $(`input[name="${checkboxName}"]:checked`).each(function() {
                            queryParams.append(checkboxName, $(this).val());
                        });
    
                        
                        //let selectedCollections = [];
                        let request = '/gs';
                        
                        //if keywords is empty add the general search terms
                        if (keywords.length === 0)
                        {
                            keywords.push($('input[name=generalsearch]').val());
                        }

                        queryParams.set('q', keywords.join('+ '));
                        queryParams.set('page', 1); // Reset to the first page when a keyword is removed
                        queryParams.set('collection', selectedCollection);

                        if ($('#gsearch').attr('action') === 'resourcesearch') {
                            queryParams.append('nochangedp', 'yes');
                        }

                        // Show the spinner right before calling fetch
                        spinner.style.display = 'flex';

                        // Send data using fetch API
                        fetch(mspcKeywordSearchUrl(keywords) ?? `/s?${queryParams}`, {
                                method: 'GET', // or 'POST'
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                                //body: formData
                            })
                            .then((response) => {
                                // Hide the spinner when we start processing the response
                                spinner.style.display = 'none';
                                return response.text();
                            }) // or response.json() if you're expecting JSON
                            .then((html) => {
                                currentPage = 1;
                                // Insert the HTML into the partial view
                                const partialViewContainer = document.getElementById('searchResult');
                                partialViewContainer.innerHTML = html;
                                updateKeywordLabels();
                                // Now that the new HTML is inserted, you can query it to find the results length
                                // Let's assume the <p> containing the results length has an ID of 'resultsLength'
                                const resultsLengthParagraph = partialViewContainer.querySelector('#resultsLength');

                                if (resultsLengthParagraph) {
                                    // Extract the results length from the paragraph's text content
                                    const resultsLength = resultsLengthParagraph.textContent.match(/\d+/)[0];
                                    const results = document.getElementById('results');
                                    if (results) {
                                        results.textContent = (resultsLength === '2000') ? ` ${resultsLength + '+'} ` : ` ${resultsLength} `;
                                    }
                                }

                                //input.value = ''; // Clear the visible input field
                                datePickerFunction();
                                // Attach a change event listener to checkboxes with the class 'form-check-input'
                                $('.form-check-input').on('change', function () {
                                    filterCards();
                                    datePickerDates();
                                });

                                //MIL-310
                                checkboxFiltersAccebility();

                                shouldHideMobileFilter();
                            })
                            .catch((error) => {
                                // It's important to hide the spinner even if the fetch fails
                                spinner.style.display = 'none';
                                console.error('Error:', error);
                            });
                    } else {
                        // The last keyword was removed: reset like the "Clear All" button.
                        clearAllResults();
                    }

            });

            // label.textContent = keyword;
            labelsContainer.appendChild(equationContainer);
            if (index === keywords.length - 1) {
                    equalsSign = createEquationPart('=');
                    // Create the results box
                    resultsBox = createStyledBox('Results', '');
                    resultsBox.style.fontWeight = '500';
                    resultsBox.style.border = "none";
                    resultsBox.style.paddingLeft = "0";
                    labelsContainer.appendChild(equalsSign);
                    labelsContainer.appendChild(resultsBox);

                    // Create the container div
                    div = document.createElement('div');
                    div.className = 'd-flex justify-content-md-end';

                    // Create the button
                    button = document.getElementById('clearFilters');

                    // Add a click event listener to the button
                    button.addEventListener('click', clearAllResults);

                    // Append the button to the div
                    labelsContainer.appendChild(div);
                }
            });
    }
    

function fetchReults(keywords) {
            // Construct the query string
            let input = $('input[name=generalsearch]').val();
            const selectedCollection = $('input[type="radio"][name="inputAccordion"]:checked, input[type="radio"][name="inputAccordionMobile"]:checked').data('collection');
            const selectedTypeSearch = $('input[type="radio"][name="searchOptions"]:checked').attr('searchtype');
            let queryParams = new URLSearchParams();
            let action = "";
            // Collect Checkboxes (Simplified logic)
            const checkboxName = action === 'resourcesearch' ? 'resourcescollectionChoice[]' : (action === 'readingroomsearch' ? 'collectionReadingRoomChoice[]' : 'collectionChoice[]');
            
            console.log(checkboxName);

            $(`input[name="${checkboxName}"]:checked`).each(function() {
                queryParams.append(checkboxName, $(this).val());
            });
            
            //if keywords is empty add the general search terms
            if (keywords.length === 0)
            {
                keywords.push($('input[name=generalsearch]').val());
            }

            queryParams.set('q', keywords.join('+ '));

            if ($('#gsearch').attr('action') === 'resourcesearch') {
                queryParams.append('nochangedp', 'yes');
            }
            queryParams.set('collection', selectedTypeSearch);
            queryParams.set('page', 1);

            // Show the spinner right before calling fetch
            spinner.style.display = 'flex';

            // Send data using fetch API
            fetch(mspcKeywordSearchUrl(keywords) ?? `/s?${queryParams}`, {
                    method: 'GET', // or 'POST'
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                    //body: formData
                })
                .then((response) => {
                    // Hide the spinner when we start processing the response
                    spinner.style.display = 'none';
                    return response.text();
                }) // or response.json() if you're expecting JSON
                .then((html) => {
                    currentPage = 1;
                    // Insert the HTML into the partial view
                    const partialViewContainer = document.getElementById('searchResult');
                    partialViewContainer.innerHTML = html;
                    updateKeywordLabels();
                    // Now that the new HTML is inserted, you can query it to find the results length
                    // Let's assume the <p> containing the results length has an ID of 'resultsLength'
                    const resultsLengthParagraph = partialViewContainer.querySelector('#resultsLength');

                    if (resultsLengthParagraph) {
                        // Extract the results length from the paragraph's text content
                        const resultsLength = resultsLengthParagraph.textContent.match(/\d+/)[0];
                        const results = document.getElementById('results');
                        if (results) {
                            results.textContent = (resultsLength === '2000') ? ` ${resultsLength + '+'} ` : ` ${resultsLength} `;
                        }
                    }

                    //input.value = ''; // Clear the visible input field
                    datePickerFunction();
                    // Attach a change event listener to checkboxes with the class 'form-check-input'
                    $('.form-check-input').on('change', function () {
                        filterCards();
                        datePickerDates();
                    });

                    //MIL-310
                    checkboxFiltersAccebility();

                    shouldHideMobileFilter();
                })
                .catch((error) => {
                    // It's important to hide the spinner even if the fetch fails
                    spinner.style.display = 'none';
                    console.error('Error:', error);
                });
    }


(function(){
    

    function fetchReultsDates(keywords) {
            // Construct the query string
            let input = $('input[name=generalsearch]').val();
            let request = '/gs';
            let selectedCollections = [];
            let queryParams = new URLSearchParams();
            let selectedCollection = $('input[name="inputAccordion"]:checked, input[name="inputAccordionMobile"]:checked').data('collection');

            if ($('#gsearch').attr('action') === 'onlinecollectionssearch') {
                request = '/onlinecollectionssearch';

                if ($('input[name="collectionChoice[]"]:checked').val() === "selectAllOnlineCollections") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });
                }

                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collectionChoice[]', collection);
                });
            }
            if ($('#gsearch').attr('action') === 'readingroomsearch') {
                request = '/readingroomssearch';

                if ($('input[name="collectionReadingRoomChoice[]"]:checked').val() === "selectAllReadingRooms") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionReadingRoomChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionReadingRoomChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });
                }

                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collectionReadingRoomChoice[]', collection);
                });
            }
            if ($('#gsearch').attr('action') === 'resourcesearch') {
                request = '/resourcesearch';
                if ($('input[name="resourcescollectionChoice[]"]:checked').val() === "selectAllResources") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="resourcescollectionChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                    selectedCollections.push('siteresourcesdata');
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="resourcescollectionChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });
                }
                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('resourcescollectionChoice[]', collection);
                });
            }

            
            if (selectedCollection) {
                queryParams.set('collection', selectedCollection);
            } else {
                queryParams.set('collection', 'sitewide'); 
            }

            //if keywords is empty add the general search terms
            if (keywords.length === 0)
            {
                keywords.push($('input[name=generalsearch]').val());
            }
                

            queryParams.set('q', keywords.join('+ '));


            // Manually append other form fields
            let startDate = document.querySelector('[name="startDate"]').value;
            let endDate = document.querySelector('[name="endDate"]').value;

            if (startDate) {
                queryParams.set('startDate', startDate);
            }
            if (endDate) {
                queryParams.set('endDate', endDate);
            }

            if ($('#gsearch').attr('action') === 'resourcesearch') {
                queryParams.set('nochangedp', 'no');
            } else {
                queryParams.set('nochangedp', 'yes');
            }


            // Show the spinner right before calling fetch
            spinner.style.display = 'flex';

            // Send data using fetch API
            fetch(`/s?${queryParams}`, {
                    method: 'GET', // or 'POST'
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                    //body: formData
                })
                .then((response) => {
                    // Hide the spinner when we start processing the response
                    spinner.style.display = 'none';
                    return response.text();
                }) // or response.json() if you're expecting JSON
                .then((html) => {
                    currentPage = 1;
                    // Insert the HTML into the partial view
                    const partialViewContainer = document.getElementById('searchResult');
                    partialViewContainer.innerHTML = html;
                    updateKeywordLabels();
                    // Now that the new HTML is inserted, you can query it to find the results length
                    // Let's assume the <p> containing the results length has an ID of 'resultsLength'
                    const resultsLengthParagraph = partialViewContainer.querySelector('#resultsLength');

                    if (resultsLengthParagraph) {
                        // Extract the results length from the paragraph's text content
                        const resultsLength = resultsLengthParagraph.textContent.match(/\d+/)[0];
                        const results = document.getElementById('results');
                        if (results) {
                            results.textContent = (resultsLength === '2000') ? ` ${resultsLength + '+'} ` :
                                ` ${resultsLength} `;
                        }
                    }

                    //input.value = ''; // Clear the visible input field
                    datePickerFunction();
                    // Attach a change event listener to checkboxes with the class 'form-check-input'
                    $('.form-check-input').on('change', function () {
                        filterCards();
                        datePickerDates();
                    });
                    shouldHideMobileFilter();
                    //MIL-310
                    checkboxFiltersAccebility();

                    document.addEventListener("DOMContentLoaded", function () {
                        document.querySelectorAll('.irishsword-accordion .accordion-button')
                            .forEach((button) => {
                                const collapseId = button.getAttribute('data-bs-target');
                                const toggleSpan = button.querySelector('.toggle-text');

                                if (collapseId && toggleSpan) {
                                    const collapseEl = document.querySelector(collapseId);

                                    collapseEl.addEventListener('shown.bs.collapse',
                                        function () {
                                            toggleSpan.textContent = 'Less';
                                        });

                                    collapseEl.addEventListener('hidden.bs.collapse',
                                        function () {
                                            toggleSpan.textContent = 'More';
                                        });
                                }
                            });
                    });
                })
                .catch((error) => {
                    // It's important to hide the spinner even if the fetch fails
                    spinner.style.display = 'none';
                    console.error('Error:', error);
                });
    }

    // 3. Helper for re-initializing components after HTML is injected
    function postSearchInit(html) {
            if (typeof filterCards === "function") {
                filterCards();
            }
            // Initialize date pickers, scroll progress, etc.
            if (typeof datePickerFunction === "function") 
            {
                datePickerFunction();
            }
            if (typeof checkboxFiltersAccebility === "function") 
            {
                checkboxFiltersAccebility();
            }
                    
            // Update the results counter logic
            const resultsParagraph = document.querySelector('#resultsLength');
            if (resultsParagraph) {
                const count = resultsParagraph.textContent.match(/\d+/)[0];
                const results = document.getElementById('results');
                if (results) {
                    results.textContent = (count >= 20) ? `${count} ` : count;
                }
            }

            // Detach any existing submit event handlers from #searchForm
            $(document).off('submit', '#searchForm');
            $(document).off('submit', '#searchFormDates');

            // Attach the submit event
            $(document).on('submit', '#searchForm', function (event) {
                event.preventDefault();

                // Nothing is sent and the results stay as they are when the keyword is too short (search-min-length).
                if (!validateSearchText([document.getElementById('queryInput')])) {
                    return;
                }

                let input = $('#queryInput').val();
                let hiddenInput = document.getElementById('concatenatedKeywords');
                let newKeyword = input.trim();
                if (newKeyword && !html.includes('500: Something went wrong..')) {

                    // splitKeywords(newKeyword).filter(item=>!keywords.includes(item)).forEach((keyword, index) => {
                    //     keywords.push(keyword);
                    // });
                    keywords.push(newKeyword);
                    updateKeywordLabels();
                    fetchReults(keywords);
                }
                });

                // Attach the submit event
                $(document).on('submit', '#searchFormDates', function (event) {
                    event.preventDefault();
                    fetchReultsDates(keywords);
                });
            
                scrollProgress();
    }


    //Heading fields search
        $('#searchHeadingFields').click((e) => {
            let queryParams = new URLSearchParams();
            let selectedCollections = [];
            let request = '/headingfields';
            var isIraChecked = $('#orgIRA').is(':checked');

            // Typed words need the minimum length and an empty panel needs another criterion; nothing is
            // sent and the results stay as they are otherwise (search-min-length).
            const headingPanel = document.getElementById('flush-collapseFields');
            const headingTextInputs = Array.from(headingPanel ? headingPanel.querySelectorAll('.js-search-text') : [])
                .filter((input) => input.getClientRects().length > 0);
            if (!validateSearchText(headingTextInputs, panelHasOtherCriterion(headingPanel))) {
                return;
            }

            currentPage = 1;
            queryParams.set('page', currentPage);
            
            $('input[name=generalsearch]').val("");
            // Collect year filters
            const selectedYears = [];
            $('input[name="yearFilter[]"]:checked').each(function () {
                selectedYears.push($(this).val());
            });
            selectedYears.forEach((year) => queryParams.append('year[]', year));

            // Collect organisation filters
            const selectedOrgs = [];
            $('input[name="orgFilter[]"]:checked').each(function () {
                selectedOrgs.push($(this).val());
            });
            selectedOrgs.forEach((org) => queryParams.append('organisation[]', org));

            if ($('#gsearch').attr('action') === 'onlinecollectionssearch') {
                //request = '/onlinecollectionssearch';

                if ($('input[name="collectionChoice[]"]:checked').val() ===
                    "selectAllOnlineCollections") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });

                    switch ($('input[name="collectionChoice[]"]:checked').val()) {
                        case "bmhcdindex":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "mspc":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('section', fatalityCategory($('#search_section_select').val()));
                            break;
                        case "bmhwitnesses":
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('firstname', $('#search_firstnamewitness').val());
                            queryParams.set('surname', $('#search_surnamewitness').val());
                            break;
                        case "bmhgallery":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('caption', $('#search_caption').val());
                            queryParams.set('album', $('#search_album').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            break;
                        case "collins":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "census":
                            queryParams.set('firstname', $('#search_firstname').val());
                            queryParams.set('surname', $('#search_surname').val());
                            queryParams.set('age', $('#search_age').val());
                            queryParams.set('nextofkinfirstname', $('#search_nextofkinfirstname')
                                .val());
                            queryParams.set('nextofkinsurname', $('#search_nextofkinsurname').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "gallery":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('caption', $('#search_caption').val());
                            queryParams.set('album', $('#search_album').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "mpdsearch":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('location', $('#search_location').val());
                            queryParams.set('to', $('#search_year').val());
                            break;
                        case "irishvol":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('subtitle', $('#search_subtitle').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                            break;
                        case "antoglac":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('subtitle', $('#search_subtitle').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('from', $('#search_from').val());
                            queryParams.set('to', $('#search_to').val());
                        case "oralhistories":
                            queryParams.set('title', $('#search_title').val());
                            queryParams.set('reference', $('#search_file_references').val());
                            queryParams.set('keywords', $('#search_scope_content').val());
                            queryParams.set('interviewee', $('#search_interviewee').val());
                            queryParams.set('location', $('#search_location').val());
                        case "nominalrolls":
                            queryParams.set('year1921', $('#year1921').is(':checked') ? $('#year1921')
                                .val() : '');
                            queryParams.set('year1922', $('#year1922').is(':checked') ? $('#year1922')
                                .val() : '');
                            queryParams.set('orgIRA', $('#orgIRA').is(':checked') ? $('#orgIRA').val() :
                                '');
                            queryParams.set('orgCumann', $('#orgCumann').is(':checked') ? $(
                                '#orgCumann').val() : '');
                            queryParams.set('orgFianna', $('#orgFianna').is(':checked') ? $(
                                '#orgFianna').val() : '');
                            queryParams.set('orgICA', $('#orgICA').is(':checked') ? $('#orgICA').val() :
                                '');

                            // HIDDEN LOGIC: If IRA is checked, also send these specific values
                            // These correspond to the values previously held by orgIrishVol and orgHibernian
                           
                           if (isIraChecked) {
                            // These keys match your PHP $orgs array
                            queryParams.set('orgIrishVol', 'Irish Volunteers');
                            queryParams.set('orgHibernian', 'Hibernian Rifles');
                            
                            // Also keep the individual params if your PHP specifically looks for these keys
                            queryParams.set('orgIrishVol', 'Irish Volunteers');
                            queryParams.set('orgHibernian', 'Hibernian Rifles');
                            } else {
                                queryParams.set('orgIrishVol', '');
                                queryParams.set('orgHibernian', '');
                            }    
                            
                            queryParams.set('search_file_references', $('#search_file_references')
                                .val());
                            queryParams.set('search_firstname', $('#search_firstname').val());
                            queryParams.set('search_surname', $('#search_surname').val());
                            queryParams.set('search_location', $('#search_location').val());
                            queryParams.set('search_address', $('#search_address').val());
                            queryParams.set('search_brigade', $('#search_brigade').val());
                        default:
                            // code block
                    }

                }

                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collection[]', collection);
                });
            }
            if ($('#gsearch').attr('action') === 'readingroomsearch') {
                //request = '/readingroomssearch';

                if ($('input[name="collectionReadingRoomChoice[]"]:checked').val() ===
                    "selectAllReadingRooms") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionReadingRoomChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="collectionReadingRoomChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });
                }
                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collection[]', collection);
                });
            }
            if ($('#gsearch').attr('action') === 'resourcesearch') {
                //request = '/resourcescollectionsearch';

                if ($('input[name="resourcescollectionChoice[]"]:checked').val() ===
                    "selectAllResources") {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="resourcescollectionChoice[]"]:not(:checked)').each(function () {
                        selectedCollections.push($(this).val());
                    });
                    selectedCollections.push('siteresourcesdata');

                } else {
                    // Get all checked checkboxes from the dropdown
                    $('input[name="resourcescollectionChoice[]"]:checked').each(function () {
                        selectedCollections.push($(this).val());
                    });

                    switch ($('input[name="resourcescollectionChoice[]"]:checked').val()) {
                        case "irish-sword":
                            queryParams.set('titleirishsword', $('#search_titleirishsword').val());
                            queryParams.set('season', $('#search_date').val());
                            queryParams.set('articlename', $('#search_articlename').val());
                            queryParams.set('author', $('#search_author').val());
                            queryParams.set('issue', $('#search_issue').val());
                            queryParams.set('volume', $('#search_volume').val());
                            queryParams.set('keyword', $('#search_keywordirishsword').val());
                        default:
                            // code block
                    }

                }

                // Add the array of selected collections to the query parameters
                selectedCollections.forEach((collection) => {
                    queryParams.append('collection[]', collection);
                });
            }

            // The pre-filled From/To range is not a criterion for the server guard (search-min-length).
            if (multiFieldDatesUntouched()) {
                queryParams.set('datesDefault', '1');
            }

            // Show the spinner right before calling fetch
            spinner.style.display = 'flex';

            // Send data using fetch API
            fetch(`${request}?${queryParams}`, {
                    method: 'GET', // or 'POST'
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                    //body: formData
                })
                .then((response) => {
                    // Hide the spinner when we start processing the response
                    spinner.style.display = 'none';
                    return response.text();
                }) // or response.json() if you're expecting JSON
                .then((html) => {
                    // Insert the HTML into the partial view
                    let keyword = [];
                    const partialViewContainer = document.getElementById('searchResult');
                    var offset = 900;
                    var duration = 550;
                    const initialText = 'More';
                    // Initially hide all items beyond the first 100
                    var clickedValue = $('input[name="collectionChoice[]"]:checked').val();
                    var clickedValueReading = $(
                        'input[name="collectionReadingRoomChoice[]"]:checked').val();
                                        var height = $(document).height();
                    var buttons = document.getElementsByClassName("moreLessButton");
                    var i = 0;
                    //let input = $('input[name=generalsearch]').val();
                    let input = "";

                    partialViewContainer.innerHTML = html;
                    
                    input += (input === '') ? ($('#search_scope_content').val() !== '') ? $(
                        '#search_scope_content').val() : '' : ($('#search_scope_content')
                        .val() !== '') ? ", " + $('#search_scope_content').val() : '';
                    input += (input === '') ? ($('#search_file_references').val() !== '') ? $(
                        '#search_file_references').val() : '' : ($('#search_file_references')
                        .val() !== '') ? ", " + $('#search_file_references').val() : '';
                    input += (input === '') ? ($('#search_subtitle').val() !== '') ? $(
                            '#search_subtitle').val() : '' : ($('#search_subtitle').val() !== '') ?
                        ", " + $('#search_subtitle').val() : '';
                    input += (input === '') ? ($('#search_title').val() !== '') ? $('#search_title')
                        .val() : '' : ($('#search_title').val() !== '') ? ", " + $('#search_title')
                        .val() : '';
                    input += (input === '') ? ($('#search_firstname').val() !== '') ? $(
                            '#search_firstname').val() : '' : ($('#search_firstname').val() !== '') ?
                        ", " + $('#search_firstname').val() : '';
                    input += (input === '') ? ($('#search_surname').val() !== '') ? $(
                            '#search_surname').val() : '' : ($('#search_surname').val() !== '') ?
                        ", " + $('#search_surname').val() : '';
                    input += (input === '') ? ($('#search_age').val() !== '') ? $('#search_age')
                        .val() : '' : ($('#search_age').val() !== '') ? ", " + $('#search_age')
                    .val() :
                        '';
                    input += (input === '') ? ($('#search_nextofkinfirstname').val() !== '') ? $(
                        '#search_nextofkinfirstname').val() : '' : ($(
                        '#search_nextofkinfirstname').val() !== '') ? ", " + $(
                        '#search_nextofkinfirstname').val() : '';
                    input += (input === '') ? ($('#search_nextofkinsurname').val() !== '') ? $(
                        '#search_nextofkinsurname').val() : '' : ($('#search_nextofkinsurname')
                        .val() !== '') ? ", " + $('#search_nextofkinsurname').val() : '';
                    input += (input === '') ? ($('#search_caption').val() !== '') ? $(
                            '#search_caption').val() : '' : ($('#search_caption').val() !== '') ?
                        ", " + $('#search_caption').val() : '';
                    input += (input === '') ? ($('#search_album').val() !== '') ? $('#search_album')
                        .val() : '' : ($('#search_album').val() !== '') ? ", " + $('#search_album')
                        .val() : '';
                    input += (input === '') ? ($('#search_county').val() !== '') ? $('#search_county')
                        .val() : '' : ($('#search_county').val() !== '') ? ", " + $('#search_county')
                        .val() : '';

                    let hiddenInput = $('#concatenatedKeywords');
                    let newKeyword = input.trim();
                    let itemsToShow = 5;

                    // Bind the scroll event
                    $(window).on('scroll', onScroll);

                    if (newKeyword && !html.includes('500: Something went wrong..')) {
                        keywords = [];
                        //splitKeywords(newKeyword).filter(item => !keywords.includes(item)).forEach((keyword, index) => {
                        //    keywords.push(keyword);
                        //);
                        keywords.push(newKeyword);
                        //updateKeywordLabels();
                    }


                    datePickerFunction();
                    // Now that the new HTML is inserted, you can query it to find the results length
                    // Let's assume the <p> containing the results length has an ID of 'resultsLength'
                    const resultsLengthParagraph = partialViewContainer.querySelector(
                        '#resultsLength');

                    if (resultsLengthParagraph) {
                        // Extract the results length from the paragraph's text content
                        const resultsLength = resultsLengthParagraph.textContent.match(/\d+/)[0];
                        const results = document.getElementById('results');
                        if (results)
                        {
                            results.textContent = (resultsLength === '2000') ?
                            ` ${resultsLength + '+'} ` : ` ${resultsLength} `;
                        }
                            
                    }

                    // Detach any existing submit event handlers from #searchForm
                    $(document).off('submit', '#searchForm');
                    $(document).off('submit', '#searchFormDates');

                    // Attach the submit event
                    $(document).on('submit', '#searchForm', function (event) {
                        event.preventDefault();

                        // Nothing is sent and the results stay as they are when the keyword is too short (search-min-length).
                        if (!validateSearchText([document.getElementById('queryInput')])) {
                            return;
                        }

                        let input = $('#queryInput').val();
                        let hiddenInput = document.getElementById('concatenatedKeywords');
                        let newKeyword = input.trim();
                        if (newKeyword && !html.includes('500: Something went wrong..')) {

                            // splitKeywords(newKeyword).filter(item=>!keywords.includes(item)).forEach((keyword, index) => {
                            //     keywords.push(keyword);
                            // });
                            keywords.push(newKeyword);
                            updateKeywordLabels();
                            fetchReults(keywords);
                        }
                    });

                    // Attach the submit event
                    $(document).on('submit', '#searchFormDates', function (event) {
                        event.preventDefault();
                        fetchReultsDates(keywords);
                    });

                    function scrollToResults() {
                        if ($(window).width() < 991) {
                            let top = 1250;
                            if ($(window).width() >= 375 && $(window).width() <= 414) {
                                top = 1300;
                            }
                            if ($(window).width() >= 412 && $(window).width() <= 540) {
                                top = 1000;
                            }

                            $('html, body').animate({
                                scrollTop: $("#search-results").offset().top - top
                            });
                        } else {
                            $('html, body').animate({
                                scrollTop: $("#search-results").offset().top
                            });
                        }
                    }
                    scrollToResults();

                    $('#viewResults').on('click', function () {

                        $(window).scrollTop($('#searchResultsAnchor').offset().top);

                    });

                    function accordionCollapse() {
                        if ($(window).width() < 991) {
                            $(".accordion-button").addClass("collapsed");
                            $(".accordion-button").attr("aria-expanded", "false");
                            $(".accordion-collapse").removeClass("show");
                        };
                    }

                    accordionCollapse();
                    focusAccordion();

                    function scrollProgress() {
                        var progressPath = document.querySelector('.progress-wrap path');
                        var pathLength = progressPath.getTotalLength();
                        var offset = 900;
                        var duration = 550;
                        var updateProgress = function () {
                            var scroll = $(window).scrollTop();
                            var height = $(document).height() - $(window).height();
                            var progress = pathLength - (scroll * pathLength / height);
                            progressPath.style.strokeDashoffset = progress;
                        };
                        progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
                        
                        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
                        progressPath.style.strokeDashoffset = pathLength;
                        progressPath.getBoundingClientRect();
                        progressPath.style.transition = progressPath.style.WebkitTransition =
                            'stroke-dashoffset 10ms linear';
                        
                        updateProgress();
                        $(window).scroll(updateProgress);
                       
                        jQuery(window).on('scroll', function () {
                            if (jQuery(this).scrollTop() > offset) {
                                jQuery('.progress-wrap').addClass('active-progress');
                            } else {
                                jQuery('.progress-wrap').removeClass('active-progress');
                            }
                        });
                        jQuery('.progress-wrap').on('click', function (event) {
                            event.preventDefault();
                            jQuery('html, body').animate({
                                scrollTop: 0
                            }, duration);
                            return false;
                        });
                    }
                    

                    scrollProgress();

                    for (i; i < buttons.length; i++) {
                        buttons.item(i).addEventListener('click', function handleClick() {
                            if (
                                this.firstElementChild.textContent.toLowerCase().includes(
                                    initialText.toLowerCase())
                            ) {
                                this.firstElementChild.textContent = 'Less';
                            } else {
                                this.firstElementChild.textContent = initialText;
                            }

                        });
                    }

                    $(document).ready(function () {
                        // Attach a change event listener to checkboxes with the class 'form-check-input'
                        $('.form-check-input').on('change', function () {
                            filterCards();
                            datePickerDates();
                        });
                    });

                    input.value = ''; // Clear the visible input field

                    shouldHideMobileFilter();
                    
                })
                .catch((error) => {
                    // It's important to hide the spinner even if the fetch fails
                    spinner.style.display = 'none';
                    console.error('Error:', error);
                });


        });

    // 2. Modularized Fetch Function
    function executeSearch(page = 1, append = false) {
        const spinner = document.getElementById('spinner'); // Ensure this ID matches your HTML
        const searchInput = $('input[name=generalsearch]');
        const form = $('#gsearch');
        let input = $('input[name=generalsearch]').val();
                
        let request = '/gs'; // Default
        let queryParams = new URLSearchParams();
        let selectedCollections = [];
        let hiddenInput = $('#concatenatedKeywords');
        let newKeyword = input.trim();
        let itemsToShow = 5;

        // Set standard params
        queryParams.set('generalsearch', searchInput.val());
        queryParams.set('page', page);

        // Identify the route based on the form action
        const action = form.attr('action');

        // "Military Service Pensions Collection" has no dedicated route like the others below; it
        // stays on the default /gs but scopes the search to MSPC indices via this collection param
        // instead of the full sitewide index list (AMI-1 / AMI-12). Scoped to the default route only,
        // so it can't interfere with the collectionChoice[]-based params the other routes use.
        // Read the checked radio directly (not the hidden #selectedCollection field, which is only
        // set reactively on 'change' and goes stale if the radio was already checked from an earlier
        // interaction - e.g. the user re-searches a new term without re-clicking the radio).
        if (action !== 'onlinecollectionssearch' && action !== 'readingroomsearch' && action !== 'resourcesearch') {
            const checkedSearchOption = $('input[name="searchOptions"]:checked').val();
            if (checkedSearchOption === 'mspc') {
                queryParams.set('collection', 'mspc_medals_pensions');
            }
        }
        if (action === 'onlinecollectionssearch') 
        {
            request = '/onlinecollectionssearch';
        }
        else if (action === 'readingroomsearch') 
        {
            request = '/readingroomssearch';
        }
        else if (action === 'resourcesearch') 
        {
            request = '/resourcesearch';
        }

        // Collect Checkboxes (Simplified logic)
        const checkboxName = action === 'resourcesearch' ? 'resourcescollectionChoice[]' : 
        (action === 'readingroomsearch' ? 'collectionReadingRoomChoice[]' : 'collectionChoice[]');
                
        $(`input[name="${checkboxName}"]:checked`).each(function() {
            queryParams.append(checkboxName, $(this).val());
        });

        spinner.style.display = 'flex';

        fetch(`${request}?${queryParams}`, {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then((response) => response.text())
        .then((html) => {
            keywords = [];
            spinner.style.display = 'none';
            currentPage = 1;
            const container = document.getElementById('searchResult');
                    

            if (append) {
                // Used for "Load More" style pagination
                container.insertAdjacentHTML('beforeend', html);
            } else {
                // Used for a fresh search
                container.innerHTML = html;
                window.scrollTo({ top: $("#search-results").offset()?.top || 0, behavior: 'smooth' });
            }

            // Re-initialize logic that depends on new HTML
            currentSearchPage = page;
        

            if (newKeyword && !html.includes('500: Something went wrong..')) {
                //let keywords = [];
            
                keywords.push(newKeyword);
                updateKeywordLabels();
            }
            postSearchInit(html);
            //datePickerFunction();
            
            })
            .catch((error) => {
                spinner.style.display = 'none';
                console.error('Search Error:', error);
            });
    }
    // 4. Primary Form Listener
    $('#gsearch').on('submit', function (event) {
        event.preventDefault();
        // A short or empty quick search is not sent and the results already on the page stay (search-min-length).
        if (!validateSearchText([document.getElementById('generalsearch')])) {
            return;
        }
        keywords = [];
        clearMspcPanelState();
        executeSearch(1, false); // Reset to page 1 for new searches
    });
}());